import axios from "axios";

const API = axios.create({
    baseURL: "https://homefoods-backend-production.up.railway.app/api",
});

API.interceptors.request.use((config) => {

    const token = localStorage.getItem("token");

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
});

export const getSupportStats = () =>
    API.get("/admin/support/stats");

export const getSupportTickets = () =>
    API.get("/admin/support/all");

export const getSupportTicket = (id) =>
    API.get(`/admin/support/${id}`);

export const updateSupportStatus = (id, data) =>
    API.patch(`/admin/support/${id}/status`, data);

export const assignSupportTicket = (id, data) =>
    API.patch(`/admin/support/${id}/assign`, data);

export const replySupportTicket = (id, formData) =>
    API.post(`/admin/support/${id}/reply`, formData);

export const deleteSupportTicket = (id) =>
    API.delete(`/admin/support/${id}`);